import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { FormField } from "src/components/FormField";
import { TextField } from "src/components/FormField/TextField";
import { IFormField } from "src/@types/form";
import { formFieldTrns } from "./trns";

const DEFAULT_FIELD_CLASSNAME =
  "flex !flex-row flex-1 items-center px-5 py-3 border border-black-base/20 rounded-20";
const DEFAULT_INPUT_CLASSNAME = "!p-0 border-none rounded-none";

export const MinMaxNumberField: FC<IFormField> = ({
  className,
  label,
  errorClassName,
  name,
  fieldClassName,
  labelClassName,
}) => {
  const { t } = useTranslation();

  const [minName, maxName] = name as [string, string];

  return (
    <FormField
      className={cn(fieldClassName, "!flex-row items-center")}
      label={label}
      labelClassName={labelClassName}
    >
      <TextField
        fieldClassName={DEFAULT_FIELD_CLASSNAME}
        className={cn(className, DEFAULT_INPUT_CLASSNAME)}
        errorClassName={errorClassName}
        label={t(formFieldTrns.minPlaceholder)}
        name={minName}
        type="number"
      />

      <TextField
        fieldClassName={DEFAULT_FIELD_CLASSNAME}
        className={cn(className, DEFAULT_INPUT_CLASSNAME)}
        errorClassName={errorClassName}
        label={t(formFieldTrns.maxPlaceholder)}
        name={maxName}
        type="number"
      />
    </FormField>
  );
};
